import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { ROUTE_TO_FEATURE } from "../lib/featureAccess";

const SESSION_KEY = "estima_activity_session";

function sessionId() {
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = (typeof crypto !== "undefined" && crypto.randomUUID ? crypto.randomUUID() : `as-${Date.now()}`);
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return "anon";
  }
}

function featureForPath(path) {
  // /app/portfolio -> portfolio   /app -> "" -> dashboard
  if (!path?.startsWith("/app")) return null;
  const seg = path.replace(/^\/app\/?/, "").split("/")[0];
  return ROUTE_TO_FEATURE[seg] ?? null;
}

/**
 * Logged-in-only tracker: every 30s heartbeat + a `feature_action` page_view event
 * on each route change. Used to power Admin → Live Activity console.
 */
export default function ActivityTracker() {
  const { user } = useAuth();
  const location = useLocation();
  const lastPathRef = useRef(null);

  useEffect(() => {
    if (!user || user === false) return;
    const slug = featureForPath(location.pathname);
    if (!slug) return;
    if (lastPathRef.current === location.pathname) return;
    lastPathRef.current = location.pathname;
    api.post("/activity/event", {
      event_type: "page_view",
      feature_slug: slug,
      page_path: location.pathname,
      session_id: sessionId(),
    }).catch(() => {});
  }, [user, location.pathname]);

  useEffect(() => {
    if (!user || user === false) return;
    const send = () => {
      api.post("/activity/heartbeat", {
        session_id: sessionId(),
        page_path: location.pathname,
        feature_slug: featureForPath(location.pathname) || "",
      }).catch(() => {});
    };
    send();
    const t = setInterval(send, 30000);
    return () => clearInterval(t);
  }, [user, location.pathname]);

  return null;
}
